/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupStrawIcon20Solid = forwardRef('FoodDrinkCupStrawIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.777 2.418A.5.5 0 0 1 12.271 2H16a1 1 0 1 0 0-2h-3.73a2.5 2.5 0 0 0-2.465 2.089L9.32 5H5.345a1.5 1.5 0 0 0-1.489 1.679L5.07 16.798A2.5 2.5 0 0 0 7.553 19h4.894a2.5 2.5 0 0 0 2.483-2.202l1.214-10.12A1.5 1.5 0 0 0 14.654 5h-3.307l.43-2.582Z" })));
});
